import React from 'react';
import Scroll from 'react-scroll';
import FormControl from 'react-bootstrap/FormControl';

import RegEx from '../../util/RegEx';

class FieldFile extends React.Component {

  constructor(props) {
    super(props);
    this.LabelName = this.props.field.label_name;
    this.regex = this.props.field.validate;
    this.Key = this.props.id;
    this.state = { inValid: this.props.inValid };
  }

  onChange = event => {
    const value = event.target.files;
    let inValid = {};
    if (!RegEx.isFile(value, this.regex)) inValid[this.Key] = 'Invalid Data';
    this.setState({ inValid: { ...inValid } });
    this.props.onValueChange(this.Key, value);
  };

  render() {
    let inValid = this.state.inValid;
    if (RegEx.isKeyPresent(this.props.inValid, this.Key)) inValid = this.props.inValid;
    return (
      <div className="col">
        <div className="form-group">
          <Scroll.Element name={this.Key} />
          <label>{this.LabelName}</label> {RegEx.showError(inValid, this.Key)}
          {this.props.multiple &&
            <FormControl name={this.Key} type="file" accept={this.props.document_type?.join(',') || '*'} multiple onChange={this.onChange} />
          }

          {!this.props.multiple &&
            <FormControl name={this.Key} type="file" accept={this.props.document_type?.join(',') || '*'} onChange={this.onChange} />
          }
        </div>
      </div>
    );
  }
}
export default FieldFile;